export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      background: theme.palette.grey.light,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.grey.light,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  logo: {
    position: 'absolute',
    top: '5%',
    left: '5%',
    maxWidth: 80,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 5,
      left: 5,
    },
  },
  btn: {
    position: 'absolute',
    bottom: '5%',
    left: '5%',
    maxWidth: 250,
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      bottom: 5,
      left: 5,
    },
  },
  content: {
    position: 'absolute',
    zIndex: 5,
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      minHeight: '100%',
      height: 'auto',
      background: theme.palette.grey.light,
      padding: theme.spacing(2),
    },
  },
  desc: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& > *': {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      transform: 'initial',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  },
  mainTitle: {
    color: theme.palette.blue.main,
  },
  titles: {
    color: theme.palette.red.light,
  },
});
